export const GET_TASK_STATUS_SUCCESS = 'GET_TASK_STATUS_SUCCESS';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const LOADING_MESSAGE = '请稍等...';
